export function getRealtimeMessageSenderId(message) {
  return `${message?.sender?._id || message?.sender?.id || message?.sender || ""}`;
}

export function getRealtimeMessageConversationId(message) {
  return `${message?.conversation || message?.conversationId || ""}`;
}

export function isRealtimeMessageFromCurrentUser(message, currentUserId) {
  const senderId = getRealtimeMessageSenderId(message);
  return Boolean(senderId) && senderId === `${currentUserId || ""}`;
}

export function shouldOpenMiniChatForMessage({
  message,
  currentUserId,
  hasMiniChat,
}) {
  return (
    !hasMiniChat &&
    !isRealtimeMessageFromCurrentUser(message, currentUserId) &&
    Boolean(message?.sender)
  );
}

export function shouldRouteMessageToMiniChat({
  message,
  friendId,
  conversationId,
}) {
  const senderId = getRealtimeMessageSenderId(message);
  const incomingConversationId = getRealtimeMessageConversationId(message);
  const resolvedFriendId = `${friendId || ""}`;
  const resolvedConversationId = `${conversationId || ""}`;

  return (
    (Boolean(senderId) && senderId === resolvedFriendId) ||
    (Boolean(incomingConversationId) &&
      incomingConversationId === resolvedConversationId)
  );
}
